import { useEffect, useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from '@/lib/auth';
import { api } from '@/lib/api';

import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import DashboardPage from '@/pages/DashboardPage';
import CatalogPage from '@/pages/CatalogPage';
import ClientsPage from '@/pages/ClientsPage';
import QuotesListPage from '@/pages/QuotesListPage';
import QuoteEditorPage from '@/pages/QuoteEditorPage';
import QuoteDetailPage from '@/pages/QuoteDetailPage';
import SettingsPage from '@/pages/SettingsPage';
import VerifyPage from '@/pages/VerifyPage';
import AppShell from '@/components/AppShell';

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return <AppShell>{children}</AppShell>;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function RegisterGate({ children }) {
  const [state, setState] = useState({ checked: false, allow: false });
  useEffect(() => {
    api.get('/auth/config')
      .then((r) => setState({ checked: true, allow: !!r.data?.allow_register }))
      .catch(() => setState({ checked: true, allow: false }));
  }, []);
  if (!state.checked) return null;
  if (!state.allow) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App min-h-screen text-foreground">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><RegisterGate><RegisterPage /></RegisterGate></PublicOnly>} />
            <Route path="/verify/:publicId" element={<VerifyPage />} />
            <Route path="/dashboard" element={<Protected><DashboardPage /></Protected>} />
            <Route path="/catalog" element={<Protected><CatalogPage /></Protected>} />
            <Route path="/clients" element={<Protected><ClientsPage /></Protected>} />
            <Route path="/quotes" element={<Protected><QuotesListPage /></Protected>} />
            <Route path="/quotes/new" element={<Protected><QuoteEditorPage /></Protected>} />
            <Route path="/quotes/:id/edit" element={<Protected><QuoteEditorPage /></Protected>} />
            <Route path="/quotes/:id" element={<Protected><QuoteDetailPage /></Protected>} />
            <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          richColors
          toastOptions={{
            classNames: {
              toast: 'glass !border-[var(--glass-border)] !bg-[#0F1626]/90 !text-foreground',
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
